module.exports = __webpack_public_path__ + "img/calendrier.31ebc1e6.svg";